import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalCreateActivityNoteDocument = gql`
  mutation SalesPortalCreateActivityNote(
    $chatUUID: uuid!
    $noteContent: String!
  ) {
    createNoteActivity(chat_id: $chatUUID, note_content: $noteContent) {
      crm_activity {
        uuid
        chat_uuid
        created_at
        crm_activity_notes {
          content
          uuid
        }
      }
    }
  }
`;
export type SalesPortalCreateActivityNoteMutationFn = Apollo.MutationFunction<
  Types.SalesPortalCreateActivityNoteMutation,
  Types.SalesPortalCreateActivityNoteMutationVariables
>;
export function useSalesPortalCreateActivityNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalCreateActivityNoteMutation,
    Types.SalesPortalCreateActivityNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalCreateActivityNoteMutation,
    Types.SalesPortalCreateActivityNoteMutationVariables
  >(SalesPortalCreateActivityNoteDocument, options);
}
export type SalesPortalCreateActivityNoteMutationHookResult = ReturnType<
  typeof useSalesPortalCreateActivityNoteMutation
>;
export type SalesPortalCreateActivityNoteMutationResult =
  Apollo.MutationResult<Types.SalesPortalCreateActivityNoteMutation>;
export type SalesPortalCreateActivityNoteMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalCreateActivityNoteMutation,
    Types.SalesPortalCreateActivityNoteMutationVariables
  >;
